/* RESPONSIBLE TEAM: team-reporting */

import { Highcharts } from '@highcharts/react';
import { formatPointValue } from '@/features/report-snapshots/formatters/datapoint';

export interface DataLabelFormatterContext {
  value?: number | null;
  formattedValue?: string;
  y: number;
  percentage?: number;
}

export function dataLabelFormatter(this: DataLabelFormatterContext) {
  const val = this.value ?? this.y;
  const rounded = Number(val.toFixed(1));

  const decimals = Number.isInteger(rounded) ? 0 : 1;

  return Highcharts.numberFormat(rounded, decimals);
}

export function relativeValuesDataLabelFormatter(this: DataLabelFormatterContext) {
  const percentage = this.percentage ?? 0;

  if (Number.isInteger(percentage)) {
    return `${Highcharts.numberFormat(percentage, 0)}%`;
  }

  const oneDecimal = Number(percentage.toFixed(1));
  const twoDecimals = Number(percentage.toFixed(2));

  if (oneDecimal === twoDecimals) {
    return `${Highcharts.numberFormat(percentage, 1)}%`;
  }

  return `${Highcharts.numberFormat(percentage, 2)}%`;
}

export function makeDefaultDataLabelFormatter(
  isRelative: boolean,
  isPercent: boolean,
  isDuration: boolean,
  decimals?: number,
) {
  return function (this: DataLabelFormatterContext) {
    if (isRelative) {
      return relativeValuesDataLabelFormatter.call(this);
    }

    return formatPointValue(this, { isRelative, isPercent, isDuration, decimals });
  };
}
